import { render, staticRenderFns } from "./leave_application_detail.vue?vue&type=template&id=5942d843&scoped=true"
import script from "./leave_application_detail.vue?vue&type=script&lang=js"
export * from "./leave_application_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942d843",
  null
  
)

export default component.exports